import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import {BomMaterial, PlaceholderProcessSheetTypes, ProductFormat} from 'src/app/models';
import {firstValueFrom} from "rxjs";

@Component({
    selector: 'app-process-sheet-materials-add',
    templateUrl: './process-sheet-materials-add.component.html',
    styleUrl: './process-sheet-materials-add.component.sass',
    standalone: false
})
export class ProcessSheetMaterialsAddComponent extends GenericCrudAddComponent<BomMaterial>{
  formats: ProductFormat[] = [];
  visibleWasteTooltip = false;
  visibleQTooltip = false;
  override initFormGroup(): FormGroup {
    return this.fb.group({
      productId: [null],
      productFormatId: [null],
      quantity: [null],
      waste: [null],
    })
  }

  async onProductChanged() {
    const productId = this.form?.controls['productId'].value
    if(productId){
      this.formats = await firstValueFrom(this.api.resources.product.productFormats(productId).getAll());
      if(this.formats.length === 1) this.form?.controls['productFormatId'].setValue(this.formats[0].id)
    }
  }

  override async mapFormEntity(): Promise<BomMaterial> {
    const entity = this.form!.value as BomMaterial;
    entity.waste = entity.waste.toString();
    return entity;
  }


  protected readonly placeholderProcessSheetTypes = PlaceholderProcessSheetTypes;
}
